import { addMonths } from 'date-fns';
import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ChamadoService extends BaseService {
  constructor() {
    super(`${ConfigApi.chamadoURL}`);
  }

  getFilter() {
    const filter = new Filter();
    return filter;
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.idRevenda = undefined;
    this.idColaborador = undefined;
    this.idCliente = undefined;
    this.dataInicio = addMonths(new Date(), -12);
    this.dataFim = new Date();
    this.listaStatus = '["0", "1"]';
    this.listaChamadoTipos = [];

    this.resumo = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new ChamadoService();
